import { render, staticRenderFns } from "./ConsultaPersonas.vue?vue&type=template&id=0c006f11&scoped=true"
import script from "./ConsultaPersonas.vue?vue&type=script&lang=js"
export * from "./ConsultaPersonas.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPersonas.vue?vue&type=style&index=0&id=0c006f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c006f11",
  null
  
)

export default component.exports